import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=12a7341c&lang=less"
import "./index.vue?vue&type=style&index=1&id=12a7341c&scoped=true&lang=less"

import exportComponent from "D:\\workspaceJava\\wlyc\\wlyc\\tianjing-client-web-develop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12a7341c"]])

export default __exports__